import * as React from 'react';
import {
    OutlinedInput,
    InputLabel,
    MenuItem,
    FormControl,
    Select,
    Checkbox,
    TextField,
    Box,
    Typography,
    Tooltip,
    Avatar,
} from '@mui/material';

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
    PaperProps: {
        style: {
            maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
            width: 300,
        },
    },
};

const getInitials = (fullName) => {
    const parts = fullName.trim().split(' ');
    if (parts.length === 1) return parts[0][0].toUpperCase();
    return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

function TruncatedTooltip({ children }) {
    const textRef = React.useRef(null);
    const [isTruncated, setIsTruncated] = React.useState(false);

    React.useEffect(() => {
        const el = textRef.current;
        if (el) {
            setIsTruncated(el.scrollWidth > el.clientWidth);
        }
    }, [children]);

    return isTruncated ? (
        <Tooltip title={children}>
            <Typography
                ref={textRef}
                noWrap
                sx={{
                    maxWidth: '160px',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: '14px',
                    color: '#111',
                    cursor: 'default',
                    fontFamily: 'Manrope'
                }}
            >
                {children}
            </Typography>
        </Tooltip>
    ) : (
        <Typography
            ref={textRef}
            noWrap
            sx={{
                maxWidth: '160px',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                fontSize: '14px',
                color: '#111',
                fontFamily: 'Manrope'
            }}
        >
            {children}
        </Typography>
    );
}
export default function SelectSearchDroupDown({
    label = 'Select User',
    options = [],
    selectedValue = '',
    onChange = () => { },
}) {
    const [searchTerm, setSearchTerm] = React.useState('');

    const handleChange = (event) => {
        onChange(event.target.value);
    };

    const filteredOptions = options.filter((opt) =>
        opt.name.toLowerCase().includes(searchTerm.toLowerCase())
    );

    const selectedOption = options.find((opt) => opt.name === selectedValue);

    return (



<FormControl sx={{ m: 0, width: '100%' }}>
    <Select
        id={`${label}-select`}
        value={selectedValue}
        onChange={handleChange}
        displayEmpty
        input={
            <OutlinedInput
                sx={{
                    height: 38,
                    borderRadius: '6px',
                    paddingRight: '32px',
                    display: 'flex',
                    alignItems: 'center',
                    fontFamily: 'Manrope'
                }}
            />
        }
        renderValue={() =>
            selectedOption ? (
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                    <Typography sx={{fontFamily: 'Manrope'}}>{selectedOption.name}</Typography>
                </Box>
            ) : (
                <Typography sx={{ color: '#A0AEC0', fontFamily: 'Manrope' }}>{label}</Typography>
            )
        }
        MenuProps={MenuProps}
        sx={{
            background: '#fff',
            borderRadius: '6px',
            '& .MuiSelect-select': {
                paddingTop: '8px',
                paddingBottom: '7px',
                height: 23,
                fontSize: '12px',
                color: '#64748B',
                fontFamily: 'Manrope'
            },
            '& .MuiOutlinedInput-notchedOutline': {
                borderRadius: '6px',
                fontFamily: 'Manrope'
            },
        }}
    >
        <MenuItem
            disableRipple
            disableTouchRipple
            sx={{
                position: 'sticky',
                top: 0,
                zIndex: 999,
                background: '#fff !important',
                borderRadius:'100px' ,
                fontFamily: 'Manrope',
                '& .MuiInputBase-root':{
                    borderRadius:'100px',
                    height:'38px',
                    fontFamily: 'Manrope'
                }
            }}
        >
            <TextField
                sx={{ background: '#fff', borderRadius:'100px', fontFamily: 'Manrope' }}
                fullWidth
                size="small"
                placeholder="Search..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
            />
        </MenuItem>

        {filteredOptions.map((opt) => (
            <MenuItem key={opt.name} value={opt.name} sx={{fontFamily: 'Manrope'}}>
                <TruncatedTooltip>{opt.name}</TruncatedTooltip>
            </MenuItem>
        ))}
    </Select>
</FormControl>








        // <FormControl sx={{ m: 1, width: '100%' }}>
        //     <InputLabel id={`${label}-label`} sx={{
        //         top: '-7px',
        //         fontSize: '14px',
        //         // Target when label is focused
        //         '&.Mui-focused': {
        //             top: '0px',
        //             fontSize: '16px',
        //         },
        //         // Target when input is filled (label shrinks)
        //         '&.MuiFormLabel-filled': {
        //             top: '0px',
        //             fontSize: '16px',
        //         },
        //     }}>{label}</InputLabel>
        //     <Select
        //         labelId={`${label}-label`}
        //         id={`${label}-select`}
        //         value={selectedValue}
        //         onChange={handleChange}
        //         input={<OutlinedInput label={label} sx={{
        //             height: 38,
        //             borderRadius: '50px',
        //             paddingRight: '32px',
        //             display: 'flex',
        //             alignItems: 'center',
        //         }} />}
        //         renderValue={() =>
        //             selectedOption ? (
        //                 <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
        //                    <Typography>{selectedOption.name}</Typography>
        //                 </Box>
        //             ) : (
        //                 <Typography>Select User</Typography>
        //             )
        //         }
        //         MenuProps={MenuProps}
        //         sx={{
        //             background: '#fff',
        //             borderRadius: '50px',
        //             '& .MuiSelect-select': {
        //                 paddingTop: '8px',
        //                 paddingBottom: '7px',
        //                 height: 23,
        //                 fontSize: '12px',
        //             },
        //             '& .MuiOutlinedInput-notchedOutline': {
        //                 borderRadius: '50px',
        //             },
        //         }}
        //     >
        //         <MenuItem
        //             disableRipple
        //             disableTouchRipple
        //             sx={{
        //                 position: 'sticky',
        //                 top: 0,
        //                 zIndex: 999,
        //                 background: '#fff !important',
        //             }}
        //         >
        //             <TextField
        //                 sx={{ background: '#fff' }}
        //                 fullWidth
        //                 size="small"
        //                 placeholder="Search..."
        //                 value={searchTerm}
        //                 onChange={(e) => setSearchTerm(e.target.value)}
        //             />
        //         </MenuItem>

        //         {filteredOptions.map((opt) => (
        //             <MenuItem key={opt.name} value={opt.name}>
        //                 <TruncatedTooltip>{opt.name}</TruncatedTooltip>
        //             </MenuItem>
        //         ))}
        //     </Select>
        // </FormControl>
    );
}
